export enum PasswordStrategyCodeEnum {
  MANUAL = 'manual',
  INVITATION = 'invitation'
}
